// Package sync.v3 defines the protocol buffer messages and services for
// synchronizing records to be cached by the client. These records are used
// to provide a consistent and up-to-date view of user-related data
// to drive features like `@mention`.
//
// Example usage flow:
// 1. Client calls Sync() with an old timestamp when no cache exists
// 2. Client stores the returned next_after timestamp
// 3. Client periodically calls Incremental() with stored timestamp
// 4. Client updates local cache with new/changed records

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file sync/v3/sync_service.proto (package sync.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { AssetWithActions } from "../../assets/v3/asset_service_pb";
import { file_assets_v3_asset_service } from "../../assets/v3/asset_service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sync/v3/sync_service.proto.
 */
export const file_sync_v3_sync_service: GenFile = /*@__PURE__*/
  fileDesc("ChpzeW5jL3YzL3N5bmNfc2VydmljZS5wcm90bxIHc3luYy52MyLjAQoNUmVzb3VyY2VRdWVyeRInCghyZXNvdXJjZRgBIAEoDjIVLnN5bmMudjMuU3luY1Jlc291cmNlEi4KBWFmdGVyGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEg0KBWxpbWl0GAMgASgFEhkKDGxhc3Rfc2Vlbl9pZBgEIAEoCUgBiAEBEh4KEWxhc3Rfc2Vlbl92ZXJzaW9uGAUgASgJSAKIAQFCCAoGX2FmdGVyQg8KDV9sYXN0X3NlZW5faWRCFAoSX2xhc3Rfc2Vlbl92ZXJzaW9uIj0KEkluY3JlbWVudGFsUmVxdWVzdBInCgdxdWVyaWVzGAEgAygLMhYuc3luYy52My5SZXNvdXJjZVF1ZXJ5IjgKE0luY3JlbWVudGFsUmVzcG9uc2USIQoHcmVjb3JkcxgBIAMoCzIQLnN5bmMudjMuUmVjb3JkcyLmAQoHUmVjb3JkcxInCghyZXNvdXJjZRgBIAEoDjIVLnN5bmMudjMuU3luY1Jlc291cmNlEi4KCm5leHRfYWZ0ZXIYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiAKB3JlY29yZHMYAyADKAsyDy5zeW5jLnYzLlJlY29yZBIZCgxsYXN0X3NlZW5faWQYBCABKAlIAIgBARIeChFsYXN0X3NlZW5fdmVyc2lvbhgFIAEoCUgBiAEBQg8KDV9sYXN0X3NlZW5faWRCFAoSX2xhc3Rfc2Vlbl92ZXJzaW9uIkAKBlJlY29yZBIsCgVhc3NldBgBIAEoCzIbLmFzc2V0cy52My5Bc3NldFdpdGhBY3Rpb25zSABCCAoGcmVjb3JkKkYKDFN5bmNSZXNvdXJjZRIdChlTWU5DX1JFU09VUkNFX1VOU1BFQ0lGSUVEEAASFwoTU1lOQ19SRVNPVVJDRV9BU1NFVBABMlkKC1N5bmNTZXJ2aWNlEkoKC0luY3JlbWVudGFsEhsuc3luYy52My5JbmNyZW1lbnRhbFJlcXVlc3QaHC5zeW5jLnYzLkluY3JlbWVudGFsUmVzcG9uc2UiAEJXWlVnaXRodWIuY29tL1N0b3J5dGVsbC1haS9zdG9yeXRlbGwtYWktcGxhdGZvcm0vcGtnL2dvL2RvbWFpbnMvY3AvZ2VuL3BiL3N5bmMvdjM7c3luY1YzYgZwcm90bzM", [file_assets_v3_asset_service, file_google_protobuf_timestamp]);

/**
 * ResourceQuery specifies which resources to sync and how to paginate them.
 *
 * @generated from message sync.v3.ResourceQuery
 */
export type ResourceQuery = Message<"sync.v3.ResourceQuery"> & {
  /**
   * The type of resource to sync
   *
   * @generated from field: sync.v3.SyncResource resource = 1;
   */
  resource: SyncResource;

  /**
   * For pagination: only return records modified after this timestamp.
   * - Provide an old timestamp to provide a full sync (e.g., 2019)
   * - Use previous response's next_after for subsequent pages
   * - Use last stored timestamp for incremental sync
   *
   * @generated from field: optional google.protobuf.Timestamp after = 2;
   */
  after: Timestamp;

  /**
   * Maximum number of records to return in this page.
   * Recommended: 100-1000 depending on record size and network conditions.
   * Max allowed is 1,000.
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * For cursor-based pagination: ID of the last record seen with the same timestamp.
   * Used to handle ties when multiple records have the same modified_at timestamp.
   * When provided along with 'after', only records with modified_at > after OR
   * (modified_at = after AND id > last_seen_id) will be returned.
   *
   * @generated from field: optional string last_seen_id = 4;
   */
  lastSeenId: string;

  /**
   * For cursor-based pagination: Version of the last record seen.
   * Used with last_seen_id to handle cases where a record gets updated between sync requests.
   * When provided, records with (id = last_seen_id AND version = last_seen_version) will be excluded.
   *
   * @generated from field: optional string last_seen_version = 5;
   */
  lastSeenVersion: string;
};

/**
 * Describes the message sync.v3.ResourceQuery.
 * Use `create(ResourceQuerySchema)` to create a new message.
 */
export const ResourceQuerySchema: GenMessage<ResourceQuery> = /*@__PURE__*/
  messageDesc(file_sync_v3_sync_service, 0);

/**
 * IncrementalRequest fetches records changed since the last sync.
 *
 * @generated from message sync.v3.IncrementalRequest
 */
export type IncrementalRequest = Message<"sync.v3.IncrementalRequest"> & {
  /**
   * Multiple resource types can be synced in a single request for efficiency.
   * Each query will return its own Records object in the response.
   *
   * @generated from field: repeated sync.v3.ResourceQuery queries = 1;
   */
  queries: ResourceQuery[];
};

/**
 * Describes the message sync.v3.IncrementalRequest.
 * Use `create(IncrementalRequestSchema)` to create a new message.
 */
export const IncrementalRequestSchema: GenMessage<IncrementalRequest> = /*@__PURE__*/
  messageDesc(file_sync_v3_sync_service, 1);

/**
 * IncrementalResponse contains changed records since the last sync.
 *
 * @generated from message sync.v3.IncrementalResponse
 */
export type IncrementalResponse = Message<"sync.v3.IncrementalResponse"> & {
  /**
   * One Records object per ResourceQuery in the request.
   * Results maintain the same order as the queries.
   *
   * @generated from field: repeated sync.v3.Records records = 1;
   */
  records: Records[];
};

/**
 * Describes the message sync.v3.IncrementalResponse.
 * Use `create(IncrementalResponseSchema)` to create a new message.
 */
export const IncrementalResponseSchema: GenMessage<IncrementalResponse> = /*@__PURE__*/
  messageDesc(file_sync_v3_sync_service, 2);

/**
 * Records contains a page of records for a specific resource type.
 *
 * @generated from message sync.v3.Records
 */
export type Records = Message<"sync.v3.Records"> & {
  /**
   * The resource type for all records in this page
   *
   * @generated from field: sync.v3.SyncResource resource = 1;
   */
  resource: SyncResource;

  /**
   * Timestamp for pagination and future incremental syncs.
   * - For pagination: use this value in the next request's after field
   * - For incremental sync: store this value and use it in future Incremental() calls
   *
   * @generated from field: google.protobuf.Timestamp next_after = 2;
   */
  nextAfter: Timestamp;

  /**
   * The actual records for this page. May be empty if no records
   * match the query criteria.
   *
   * @generated from field: repeated sync.v3.Record records = 3;
   */
  records: Record[];

  /**
   * ID of the last record in this page (for cursor-based pagination).
   * Use this along with next_after in the next request to handle ties
   * when multiple records have the same modified_at timestamp.
   *
   * @generated from field: optional string last_seen_id = 4;
   */
  lastSeenId: string;

  /**
   * Version of the last record in this page (for cursor-based pagination).
   * Use this along with last_seen_id to ensure exact record identification.
   *
   * @generated from field: optional string last_seen_version = 5;
   */
  lastSeenVersion: string;
};

/**
 * Describes the message sync.v3.Records.
 * Use `create(RecordsSchema)` to create a new message.
 */
export const RecordsSchema: GenMessage<Records> = /*@__PURE__*/
  messageDesc(file_sync_v3_sync_service, 3);

/**
 * Record represents a single syncable item.
 *
 * @generated from message sync.v3.Record
 */
export type Record = Message<"sync.v3.Record"> & {
  /**
   * @generated from oneof sync.v3.Record.record
   */
  record: {
    /**
     * Asset record containing document/file metadata and available actions
     *
     * @generated from field: assets.v3.AssetWithActions asset = 1;
     */
    value: AssetWithActions;
    case: "asset";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message sync.v3.Record.
 * Use `create(RecordSchema)` to create a new message.
 */
export const RecordSchema: GenMessage<Record> = /*@__PURE__*/
  messageDesc(file_sync_v3_sync_service, 4);

/**
 * SyncResource defines the types of resources that can be synchronized.
 * Each resource type corresponds to a specific kind of data that clients
 * need to cache locally.
 *
 * @generated from enum sync.v3.SyncResource
 */
export enum SyncResource {
  /**
   * @generated from enum value: SYNC_RESOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Asset resources include documents, images, and other content items
   * that users can reference in @mentions or other features
   *
   * @generated from enum value: SYNC_RESOURCE_ASSET = 1;
   */
  ASSET = 1,
}

/**
 * Describes the enum sync.v3.SyncResource.
 */
export const SyncResourceSchema: GenEnum<SyncResource> = /*@__PURE__*/
  enumDesc(file_sync_v3_sync_service, 0);

/**
 * @generated from service sync.v3.SyncService
 */
export const SyncService: GenService<{
  /**
   * Incremental sync retrieves pages of records that have changed since the
   * last sync. This is the primary method for keeping client caches up-to-date
   * and is useful for `@mention` features and other client-side views.
   *
   * The client provides a timestamp (from previous sync) and gets back only
   * records that were created or modified after that time. This minimizes
   * network traffic and processing.
   *
   * Example request:
   * queries: [
   *   {
   *     resource: SYNC_RESOURCE_ASSET,
   *     after: "2024-01-15T10:30:00Z",  // from previous sync
   *     limit: 100 // batch size of assets to return; max 1,000 per query
   *   }
   * ]
   *
   * The response includes a new next_after timestamp that should be stored
   * for the next incremental sync call.
   *
   * @generated from rpc sync.v3.SyncService.Incremental
   */
  incremental: {
    methodKind: "unary";
    input: typeof IncrementalRequestSchema;
    output: typeof IncrementalResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sync_v3_sync_service, 0);

